import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

export default function Footer() {
  const firstHalf = categoryList.slice(0, 7);
  const secondHalf = categoryList.slice(7);

  return (
    <footer className="bg-secondary-100 pt-16 md:pt-20 pb-8">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 max-w-6xl mx-auto mb-12">
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Kategorie</h4>
            <div className="w-8 h-px bg-secondary-300 mb-3"></div>
            <div className="flex flex-col gap-2">
              {firstHalf.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  {cat.namePl}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Więcej</h4>
            <div className="w-8 h-px bg-secondary-300 mb-3"></div>
            <div className="flex flex-col gap-2">
              {secondHalf.map((cat) => (
                <a
                  key={cat.seq}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
                >
                  {cat.namePl}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Przydatne linki</h4>
            <div className="w-8 h-px bg-secondary-300 mb-3"></div>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">Strona główna</Link>
              <Link to="/artykul-kakobuy-sheet" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">Przewodnik Kakobuy</Link>
              <Link to="/porownanie-kakobuy-cssbuy" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">Porównanie platform</Link>
              <Link to="/bezpieczenstwo-kakobuy" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">Bezpieczeństwo</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">kakobuy sheet</a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-foreground-900 transition-colors">buy it now</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">Bezpieczeństwo</h4>
            <div className="w-8 h-px bg-secondary-300 mb-3"></div>
            <div className="flex flex-col gap-2">
              <p className="text-xs text-foreground-600">Korzystaj tylko z zaufanych źródeł</p>
              <p className="text-xs text-foreground-600">Weryfikuj linki przed kliknięciem</p>
              <p className="text-xs text-foreground-600">Chroń swoje dane osobowe</p>
              <p className="text-xs text-foreground-600">Nie udostępniaj haseł</p>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-300/60 pt-8 max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <p className="text-xl md:text-2xl font-heading font-bold text-foreground-900 tracking-tight">
              kakobuyfinds<span className="text-primary-500">.tattoo</span>
            </p>
            <p className="text-4xl md:text-5xl font-heading font-extrabold text-foreground-950 mt-1 tracking-tight">
              Kakobuy Spreadsheet
            </p>
            <div className="w-12 h-px bg-secondary-400 my-3"></div>
            <p className="text-xs text-foreground-500">
              Największa baza Kakobuy Finds i produktów dla polskich użytkowników.
            </p>
          </div>

          <div className="flex flex-col items-start md:items-end gap-3">
            <div className="flex items-center gap-3">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-shopping-bag-line text-sm"></i>
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} KakobuyFinds. Wszelkie prawa zastrzeżone.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}